import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Location } from "src/app/models/Location";
import { Tool } from "src/app/models/Tool";

export type LocationMoveModalData = {
  locations: Location[];
  tools: Tool[];
};

@Component({
  selector: "app-location-move-modal",
  templateUrl: "./location-move-modal.component.html",
  styleUrls: ["./location-move-modal.component.scss"],
  standalone: false,
})
export class LocationMoveModalComponent implements OnInit {
  tools: Tool[];
  locations: Location[];
  location: Location = new Location();

  constructor(
    public dialogRef: MatDialogRef<LocationMoveModalComponent, Location>,
    @Inject(MAT_DIALOG_DATA) public data: LocationMoveModalData,
  ) {}

  ngOnInit(): void {
    this.locations = this.data.locations;
    this.location.tools = this.data.tools;
  }

  onMoveLocation() {
    this.dialogRef.close(this.location);
  }

  onCancel() {
    // no need to emit any result
    this.dialogRef.close();
  }
}
